
import { op_Subtraction, addDays } from "../../fable_modules/fable-library-js.5.3.0/DateOffset.js";
import { min, max } from "../../fable_modules/fable-library-js.5.3.0/Double.js";
import { totalDays } from "../../fable_modules/fable-library-js.5.3.0/TimeSpan.js";
import { op_Division, op_Multiply, toInt32, fromParts, compare } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { Record } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, bool_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { validateTitle } from "./FormUtils.js";
import { ChallengeDurationModule_maxDays, ChallengeDurationModule_minDays } from "../Challenge.js";

/**
 * End date is StartDate + Duration days.
 */
export function endDate(ch) {
    return addDays(ch.StartDate, ch.Duration);
}

/**
 * Days remaining from now until end date, clamped to 0.
 */
export function daysRemaining(clock, ch) {
    return max(0, ~~totalDays(op_Subtraction(endDate(ch), clock.UtcNow()))) | 0;
}

/**
 * Days until challenge start, clamped to 0.
 */
export function daysToStart(clock, ch) {
    return max(0, ~~totalDays(op_Subtraction(ch.StartDate, clock.UtcNow()))) | 0;
}

/**
 * Returns (current day number, total days). Day 1 on the start date, Duration on the last day.
 * Clamped to [1..Duration] when challenge is active.
 */
export function dayNofM(clock, ch) {
    return [min(ch.Duration, max(1, ~~totalDays(op_Subtraction(clock.UtcNow(), ch.StartDate)) + 1)), ch.Duration];
}

/**
 * Progress percentage of completed/target. Caps at 100, returns 0 when target is 0.
 */
export function progressPct(completed, target) {
    if (compare(target, fromParts(0, 0, 0, false, 0)) <= 0) {
        return 0;
    }
    else {
        return min(100, ~~toInt32(op_Multiply(op_Division(completed, target), fromParts(100, 0, 0, false, 0)))) | 0;
    }
}

export class CompletenessChecklist_RowState extends Record {
    constructor(Title, Description, Activity, TargetAndDuration, Charity, CoverImage) {
        super();
        this.Title = Title;
        this.Description = Description;
        this.Activity = Activity;
        this.TargetAndDuration = TargetAndDuration;
        this.Charity = Charity;
        this.CoverImage = CoverImage;
    }
}

export function CompletenessChecklist_RowState_$reflection() {
    return record_type("Shared.HeroHelpers.CompletenessChecklist.RowState", [], CompletenessChecklist_RowState, () => [["Title", bool_type], ["Description", bool_type], ["Activity", bool_type], ["TargetAndDuration", bool_type], ["Charity", bool_type], ["CoverImage", bool_type]]);
}

/**
 * Derive the row state from current model field values. Mirrors the validation already
 * applied by the inline form in ChallengeEditView. See design doc -- Design Decisions >
 * Completeness checklist rules.
 */
export function CompletenessChecklist_derive(title, description, theme, targetAmount, duration, targetError, charitySlug, hasCoverImage) {
    return new CompletenessChecklist_RowState(!isNullOrWhiteSpace(title) && (validateTitle(title) == null), !isNullOrWhiteSpace(description), !isNullOrWhiteSpace(theme), (((targetError == null) && (compare(targetAmount, fromParts(0, 0, 0, false, 0)) > 0)) && (duration >= ChallengeDurationModule_minDays)) && (duration <= ChallengeDurationModule_maxDays), !isNullOrWhiteSpace(charitySlug), hasCoverImage);
}

//# sourceMappingURL=HeroHelpers.js.map
